import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rUstBilgi } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rUstBilgi>, rUstBilgi>(
  ActionSubTypes.API_ANASAYFAUSTBILGI,
  DefaultInputDataStateModel<pList, rUstBilgi>()
);
